<template>
  <div class="flex flex-col mt-4 gap-6">
    <div class="flex justify-center">
      <PanelTitle v-bind="membershipCardModal.fields.alreadyOrderedTitle"></PanelTitle>
    </div>
    <div>
      <InformationBox
        :title="membershipCardModal.fields.alreadyOrderedInfoBox?.fields?.title?.value"
        :description="alreadyOrderedInfoBoxContent"
        :type="InformationBoxTypes.WARNING"
        :isCircle="false"
        :useButtonSlot="false"
      ></InformationBox>
    </div>
    <div>
      <RichText :field="membershipCardModal.fields?.alreadyOrderedText" />
    </div>
    <div class="flex flex-col">
      <button class="btn btn-secondary btn-md" @click="onClose">Close</button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useSelfServicePhysicalMembershipCardStore, useAccountStore } from '@/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { LONG_MONTH_DATE } from '@/constants/formats';
import { format } from 'date-fns';
import { replaceBookmark } from '@/utils/bookmark.replace';
import InformationBox from '../InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import PanelTitle from '../PanelTitle/PanelTitle.vue';

const accountStore = useAccountStore();
const physicalCardStore = useSelfServicePhysicalMembershipCardStore();

const showModal = ref(false);
defineExpose({ showModal: () => (showModal.value = true), hideModal: () => (showModal.value = false) });

const emit = defineEmits(['closeChildModal']);

const props = defineProps<{
  membershipCardModal: any;
}>();

const alreadyOrderedInfoBoxContent = computed(() => {
  physicalCardStore.calcExpectedDeliveryDate(accountStore.identityDetails?.membershipCardRequestedDate);

  const content = props.membershipCardModal.fields.alreadyOrderedInfoBox?.fields?.content?.value;
  let value = replaceBookmark(
    'estimatedArrival',
    content ?? '',
    format(physicalCardStore.expectedArrivalDate ?? new Date(), LONG_MONTH_DATE)
  );

  const postalAddress = accountStore.identityDetails?.addresses?.find(
    (item) => item.addressType?.toLowerCase() == 'postal'
  );

  value = replaceBookmark('addressLine1', value, postalAddress?.formattedLong ?? '');
  value = replaceBookmark('addressLine2', value, '');

  return value;
});

const onClose = () => {
  emit('closeChildModal');
};
</script>
